<template>
  <div>
    <el-form ref="form" :model="form" :rules="formRule" label-width="100px">
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本参数" name="first">
          <div class="scroll_content">
            <el-form-item label="工具标题" prop="title" style="width:500px;">
              <el-input v-model="form.title" clearable placeholder="请填写工具标题"></el-input>
            </el-form-item>
            <el-form-item label="工具类别" prop="industry" style="width:500px;">
              <el-select v-model="form.industry" clearable>
                <el-option
                  v-for="(item, index) in categoryArr"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="积分">
              <el-input-number v-model="form.price" controls-position="right" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="是否原创">
              <el-radio-group v-model="form.isOriginal">
                <el-radio label="0">非原创</el-radio>
                <el-radio label="1">原创</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-tab-pane>
        <el-tab-pane label="内容描述" name="second">
          <el-form-item label="插入内容">
            <el-button type="primary" @click="insetEditorContent(1)">插入标题</el-button>
            <el-button type="primary" @click="insetEditorContent(2)">插入引用</el-button>
          </el-form-item>
          <vue-ueditor-wrap
            ref="ueditor"
            v-model="form.content"
            :destroy="false"
            :config="editorConfig"
            @ready="readyEditor"
          ></vue-ueditor-wrap>
        </el-tab-pane>
        <el-tab-pane label="预览图片" name="third">
          <div class="scroll_content">
            <el-scrollbar>
              <el-upload
                class="upload-demo"
                ref="uploadPic"
                list-type="picture"
                :data="{type:'pic'}"
                :headers="uploadHeader"
                :action="uploadPicAction"
                :file-list="picList"
                :auto-upload="false"
                :accept="allowPicFormat"
                :multiple="true"
                :limit="1"
                :on-success="successUploadPic"
                :before-upload="uploadCheckPic"
                :on-remove="removeUploadPic"
              >
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button
                  style="margin-left: 10px;"
                  size="small"
                  type="success"
                  @click="submitUploadPic"
                >开始上传</el-button>
                <div slot="tip" class="el-upload__tip" style="line-height:25px;">
                  <div>允许上传的文件类型：{{ allowPicNotice }}，单张图片最大上传限制：{{ allowPicSizeRemark }}</div>
                  <div class="green">上传图片前请先编辑好图片说明（图片名称默认为图片说明）</div>
                </div>
              </el-upload>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件" name="forth">
          <el-form-item label="下载类别">
            <el-checkbox-group v-model="downloadType" @change="checkBox">
              <el-checkbox
                v-for="(item, index) in artDownloadConfig"
                :key="index"
                :label="index"
              >{{ item }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div class="download_content">
            <el-scrollbar class="page-component__scroll">
              <!-- 本地下载 -->
              <el-form-item>
                <el-upload
                  class="upload-demo"
                  ref="uploadFile"
                  list-type="text"
                  :data="{type:'file'}"
                  :headers="uploadHeader"
                  :action="uploadPicAction"
                  :file-list="fileList"
                  :auto-upload="false"
                  :limit="1"
                  :multiple="false"
                  :accept="allowFileFormat"
                  :on-success="successUploadFile"
                  :before-upload="uploadCheckFile"
                  :on-remove="removeUploadFile"
                  v-show="downloadType.indexOf('1') >= 0"
                >
                  <el-button slot="trigger" size="small" type="primary">本地文件</el-button>
                  <el-button
                    style="margin-left: 10px;"
                    size="small"
                    type="success"
                    @click="submitUploadFile"
                  >开始上传</el-button>
                  <div
                    slot="tip"
                    class="el-upload__tip"
                  >允许上传的文件类型：{{ allowFileNotice }}，最大上传限制：{{ allowFileSizeRemark }}</div>
                </el-upload>
              </el-form-item>

              <!-- 网盘表单 -->
              <div v-for="(item, index) in downloadInfo" :key="index">
                <div v-if="item.type > 1">
                  <el-form-item
                    :label="getDownloadName(item.name, 'address')"
                    style="width:500px;"
                    v-show="downloadType.indexOf(item.type) >= 0"
                  >
                    <el-input v-model="item.url" clearable placeholder="请填写地址"></el-input>
                  </el-form-item>
                  <el-form-item
                    :label="getDownloadName(item.name, 'pwd')"
                    style="width:500px;"
                    v-show="downloadType.indexOf(item.type) >= 0"
                  >
                    <el-input v-model="item.pwd" clearable placeholder="请填写密码，可以为空"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
// 加载组件
import Vue from "vue";
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
// 加载api
import { getCategorys, addArt, getArtInfo, editArt } from "../../../../api/art";
import { getBaseConfig } from "../../../../api/index";
// 加载函数
import { getToken } from "../../../../utils/auth";
export default {
  name: "template_form",
  components: {
    VueUeditorWrap
  },
  props: {
    artId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeName: "first",
      categoryArr: [],
      artTypeArr: [],
      typeChildArr: {},
      allowPicFormat: "",
      allowPicNotice: "",
      allowPicSizeRemark: "",
      allowPicSizeValue: "",
      uploadPicAction: "",
      allowFileFormat: "",
      allowFileNotice: "",
      allowFileSizeRemark: "",
      allowFileSizeValue: "",
      uploadHeader: {
        Authorization: ""
      },
      uploadPicSuccessArr: [],
      uploadFileSuccessArr: [],
      artDownloadConfig: [],
      downloadInfo: [],
      format: [],
      picList: [],
      fileList: [],
      downloadType: [],
      form: {
        artType: "tools",
        title: "",
        industry: "",
        parentType: "",
        price: 0,
        isOriginal: "0",
        content: "",
        uploadPicList: "",
        uploadFileList: "",
        formatInfo: "",
        downloadTypeInfo: "",
        downloadList: "",
        artId: 0
      },
      formRule: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        industry: [{ required: true, message: "请选择类别", trigger: "change" }]
      },
      editorConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 440,
        // 初始容器宽度
        initialFrameWidth: "500px",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: "http://admin.azz.lc/Public/plugin/ueditor/php/controller.php",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        // UEDITOR_HOME_URL: "/static/UEditor/",
        // 配合最新编译的资源文件，你可以实现添加自定义Request Headers,详情https://github.com/HaoChuan9421/ueditor/commits/dev-1.4.3.3
        // headers: {
        //   access_token: '37e7c9e3fda54cca94b8c88a4b5ddbf3'
        // },
        toolbars: [
          [
            "Undo",
            "Redo",
            "Bold",
            "italic",
            "underline",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "emotion",
            "simpleupload",
            "insertcode",
            "autotypeset",
            "inserttable",
            "spechars",
            "link",
            "unlink"
          ]
        ]
      },
      downloadFileAttr: {
        hasLocalFile: false
      }
    };
  },
  mounted() {
    this.initPage();
    this.resetForm();
    if (this.artId != 0) {
      this.form.artId = this.artId;
      this.getArtDetail();
    }
  },
  watch: {
    artId() {
      this.resetForm();
      if (this.artId != 0) {
        this.form.artId = this.artId;
        this.getArtDetail();
      }
    }
  },
  methods: {
    // ******************************************事件************************************
    checkBox(value) {
      // 本地下载
      if (value.indexOf("1") >= 0) {
        this.downloadFileAttr.hasLocalFile = true;
      } else {
        this.downloadFileAttr.hasLocalFile = false;
      }
    },
    changeParentType(value) {
      this.form.typeChild = "";
      if (value != "" && value != undefined) {
        let child = this.artTypeArr[value].child;
        if (child != undefined) {
          this.typeChildArr = child;
        } else {
          this.typeChildArr = {};
        }
      } else {
        this.typeChildArr = {};
      }
    },
    // 提交表单
    submit() {
      return new Promise(result => {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.form.uploadPicList = JSON.stringify(this.uploadPicSuccessArr);
            this.form.uploadFileList = JSON.stringify(
              this.uploadFileSuccessArr
            );
            this.form.downloadList = JSON.stringify(this.downloadInfo);
            this.form.downloadTypeInfo = JSON.stringify(this.downloadType);
            if (this.artId != 0) {
              // 编辑
              editArt(this.form).then(res => {
                if (res.status == 200) {
                  this.$notify({
                    title: "成功",
                    message: res.message,
                    type: "success"
                  });
                  this.resetForm();
                  result(true);
                } else {
                  this.$notify({
                    title: "警告",
                    message: res.message,
                    type: "warning"
                  });
                  result(false);
                }
              });
            } else {
              addArt(this.form).then(res => {
                if (res.status == 200) {
                  this.$notify({
                    title: "成功",
                    message: res.message,
                    type: "success"
                  });
                  this.resetForm();
                  result(true);
                } else {
                  this.$notify({
                    title: "警告",
                    message: res.message,
                    type: "warning"
                  });
                  result(false);
                }
              });
            }
          } else {
            result(false);
          }
        });
      });
    },
    // 上传图片
    submitUploadPic() {
      this.$refs.uploadPic.submit();
    },
    // 上传附件
    submitUploadFile() {
      this.$refs.uploadFile.submit();
    },
    // 上传图片之前的检测
    uploadCheckPic(file) {
      let fileSize = file.size;
      let fileName = file.name;
      let fileType = file.type;
      if (fileSize > this.allowPicSizeValue) {
        this.$notify({
          title: "警告",
          message: "文件" + fileName + "大小超过限制",
          type: "warning"
        });
        return false;
      }

      if (fileType == "" || this.allowPicFormat.indexOf(fileType) == -1) {
        this.$notify({
          title: "警告",
          message: "文件" + fileName + "类型不符合要求",
          type: "warning"
        });
        return false;
      }
    },
    // 上传附件之前的检测
    uploadCheckFile(file) {
      let fileSize = file.size;
      let fileName = file.name;
      let fileType = file.type;
      if (fileSize > this.allowFileSizeValue) {
        this.$notify({
          title: "警告",
          message: "文件" + fileName + "大小超过限制",
          type: "warning"
        });
        return false;
      }

      if (fileType == "" || this.allowFileFormat.indexOf(fileType) == -1) {
        this.$notify({
          title: "警告",
          message: "文件" + fileName + "类型不符合要求",
          type: "warning"
        });
        return false;
      }
    },
    // 移除上传图片
    removeUploadPic(file) {
      let saveName = "";
      if (file.response != undefined) {
        if (this.uploadPicSuccessArr.length > 0) {
          let obj = file.response.data;
          saveName = obj.saveName;
        }
      } else {
        saveName = file.saveName;
      }

      if (saveName != "" && saveName != undefined) {
        let deleteIndex = -1;
        this.uploadPicSuccessArr.forEach((obj, index) => {
          let objSaveName = obj.saveName;
          if (objSaveName == saveName) {
            deleteIndex = index;
            return;
          }
        });

        if (deleteIndex != -1) {
          this.uploadPicSuccessArr.splice(deleteIndex, 1);
        }
      }
    },
    // 移除上传文件
    removeUploadFile(file) {
      let saveName = "";
      if (file.response != undefined) {
        if (this.uploadFileSuccessArr.length > 0) {
          let obj = file.response.data;
          saveName = obj.saveName;
        }
      } else {
        saveName = file.saveName;
      }

      if (saveName != "" && saveName != undefined) {
        let deleteIndex = -1;
        this.uploadFileSuccessArr.forEach((obj, index) => {
          let objSaveName = obj.saveName;
          if (objSaveName == saveName) {
            deleteIndex = index;
            return;
          }
        });

        if (deleteIndex != -1) {
          this.uploadFileSuccessArr.splice(deleteIndex, 1);
        }
      }
    },
    // 图片上传成功
    successUploadPic(response) {
      if (response.status == 200) {
        let des = response.data.fileDes;
        let saveName = response.data.saveName;
        let obj = {
          des: des,
          saveName: saveName,
          isUpload: 1
        };
        this.uploadPicSuccessArr.push(obj);
      } else {
        this.$notify({
          title: "警告",
          message: response.message,
          type: "warning"
        });
      }
    },
    // 附件上传成功
    successUploadFile(response, file) {
      if (response.status == 200) {
        let des = response.data.fileDes;
        let saveName = response.data.saveName;
        let fileSize = file.size;
        let obj = {
          des: des,
          saveName: saveName,
          size: fileSize,
          isUpload: 1
        };
        this.uploadFileSuccessArr.push(obj);
      } else {
        this.$notify({
          title: "警告",
          message: response.message,
          type: "warning"
        });
      }
    },
    // *****************************************方法*******************************
    // 初始化界面
    initPage() {
      // 获取行业
      getCategorys({ type: this.form.artType }).then(res => {
        this.categoryArr = res.data;
      });
      // 获取配置
      getBaseConfig({
        type:
          "upload_pic_type,upload_pic_type_format,upload_pic_size,art_download_config,upload_file_type_format,upload_file_type,upload_file_size"
      }).then(res => {
        // 图片上传的格式
        this.allowPicFormat = res.data["upload_pic_type_format"].join(",");
        // 上传图片说明
        this.allowPicNotice = res.data["upload_pic_type"].join(",");
        // 上传图片大小
        this.allowPicSizeRemark = res.data["upload_pic_size"]["remark"];
        this.allowPicSizeValue = res.data["upload_pic_size"]["size"];
        // 下载方式
        this.artDownloadConfig = res.data["art_download_config"];

        // 上传文件格式
        this.allowFileFormat = res.data["upload_file_type_format"].join(",");
        this.allowFileNotice = res.data["upload_file_type"].join(",");
        this.allowFileSizeRemark = res.data["upload_file_size"]["remark"];
        this.allowFileSizeValue = res.data["upload_file_size"]["size"];

        // 动态设置下载输入框绑定内容
        this.setDownloadInfo();
      });

      // 设置图片上传地址
      this.uploadPicAction =
        Vue.prototype.$userApiDomain + "/index/upload_to_tmp.html";

      // 设置图片上传header头
      this.uploadHeader.Authorization = getToken();
    },
    // 获取下载方式内容
    getDownloadName(item, type) {
      if (type == "address") {
        return item + "地址";
      } else if (type == "pwd") {
        return item + "密码";
      }
    },
    // 设置下载输入框绑定内容
    setDownloadInfo() {
      for (let index in this.artDownloadConfig) {
        this.downloadInfo.push({
          name: this.artDownloadConfig[index],
          type: index,
          url: "",
          pwd: ""
        });
      }
    },
    // 添加或编辑成功以后初始化表单内容
    resetForm() {
      this.$refs.form.resetFields();
      this.format = [];
      this.picList = [];
      this.fileList = [];
      this.downloadType = [];
      this.typeChildArr = {};
      this.uploadPicSuccessArr = [];
      this.uploadFileSuccessArr = [];
      this.form.industry = "";
      this.form.content = "";
      this.form.uploadPicList = "";
      this.form.uploadFileList = "";
      this.form.formatInfo = "";
      this.form.downloadTypeInfo = "";
      this.form.downloadList = "";
      this.form.price = 0;
      this.form.artId = 0;
    },
    // 获取文章详情
    getArtDetail() {
      if (this.artId == 0) {
        return;
      }
      getArtInfo({
        artID: this.artId,
        type: this.form.artType,
        isEdit: "1"
      }).then(res => {
        // 标题
        this.form.title = res.data.artInfo.title;
        // 行业
        this.form.industry = res.data.artInfo.artTypeID;

        // 价格
        this.form.price = res.data.artInfo.price;
        // 是否原创
        this.form.isOriginal = res.data.artInfo.isOriginal.toString();
        // 内容
        this.form.content = res.data.artInfo.content;
        // 图片
        if (res.data.pic.length > 0) {
          res.data.pic.forEach(obj => {
            this.picList.push({
              name: obj.name,
              url: obj.image,
              saveName: obj.saveName
            });

            this.uploadPicSuccessArr.push({
              des: obj.name,
              saveName: obj.saveName,
              isUpload: 0
            });
          });
        }
        // 附件
        if (res.data.download != undefined) {
          if (res.data.download.downloadType != undefined) {
            res.data.download.downloadType.forEach(value => {
              this.downloadType.push(value.toString());
            });
            if (this.downloadType.indexOf("1") >= 0) {
              this.downloadFileAttr.hasLocalFile = true;
              // 加载本地文件
              if (res.data.download.local != undefined) {
                let localFile = res.data.download.local[0];
                this.fileList.push({
                  name: localFile.fileName,
                  saveName: localFile.fileName
                });
                this.uploadFileSuccessArr.push({
                  des: localFile.fileName,
                  saveName: localFile.fileName,
                  isUpload: 0
                });
              }
            }

            // 整理网盘内容
            if (res.data.download.web != undefined) {
              // console.log(this.downloadInfo);
              this.downloadInfo.forEach(obj => {
                let type = obj.type;
                let objValue = res.data.download.web[type];
                if (objValue != undefined) {
                  obj.url = objValue.url;
                  obj.pwd = objValue.pwd;
                } else {
                  obj.url = "";
                  obj.pwd = "";
                }
              });
            }
          }
        }
      });
    },
    readyEditor(editorInstance) {
      this.editorObj = editorInstance;
    },
    insetEditorContent(type) {
      let insertHtml = "";
      if (type == 1) {
        insertHtml =
          '<p style="margin: 10px 0px; padding: 10px 5px; border-radius: 3px; background-color: rgb(132, 175, 155); box-shadow: rgb(132, 175, 155) 3px 3px 5px; text-shadow: rgb(255, 255, 255) 1px 1px; line-height: 1.5; white-space: normal; text-indent: 2em; text-align: left;"></p>';
      } else if (type == 2) {
        insertHtml =
          '<blockquote class="layui-elem-quote layui-quote-nm">&nbsp;</blockquote>';
      }
      window.UE.getEditor(this.editorObj.key).execCommand(
        "insertHtml",
        insertHtml
      );
    }
  }
};
</script>

<style scoped>
.download_content {
  height: 400px;
  overflow: hidden;
}
</style>